import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PropertyService } from '../../services/property.service';
import { PropertyImageService } from '../../services/property-image.service';


// @fullcalendar plugins

@Component({
    selector: 'app-property-card',
    templateUrl: './property-card.component.html',
    styleUrls: ['./property-card.component.scss']
})
export class PropertyCardComponent implements OnInit {

    @Input() property;
    @Input() config;
    loading = true;
    value: number = 0;
    constructor(
        private readonly propertyImageService: PropertyImageService
    ) {
    }

    ngOnInit() {
        this.loading = true;
        this.propertyImageService.getPropertyMainImage(this.property.uuid).then((image) => {
            this.property.main_image = image;
        }).finally(() => {
            this.loading = false;
        });
    }

    getRoute(type: string): string {
        switch (type) {
            case "admin":
                return '/admin/property'
            case "private":
                return '/b/property'
            case "public":
                return '/buildings-detail'
        }
        return ''
    }


}
